import { gql } from '@eti/schema-types';

export const GET_SELECTED_TRIP = gql(/* GraphQL */ `
  query getSelectedTripOnYourSelectedTripPage($excludedExtraProductIds: [ID]) {
    selectedTrip {
      availableETGFares {
        name
        id
        selectedOption
        options {
          id
          name
          price {
            price {
              value
            }
          }
          content {
            name
            description
            readMoreText
            included
            termsUrl
            size3d {
              height
              width
              length
            }
            weight
            weightUnit
            pieces
            productTypeId
          }
          tier
          originalPrice {
            price {
              value
            }
          }
        }
        discountPercentage
      }
      id
      isVI
      selectionKey
      brandedFares {
        availableExtraProducts(excludedExtraProducts: $excludedExtraProductIds) {
          productId: id
          name
          code
          selectedWithTrip
          sellSpecification {
            ... on SellSpecificationNoneNew {
              __typename
              price {
                markup {
                  value
                  currency {
                    code
                  }
                }
                price {
                  value
                  currency {
                    code
                  }
                }
                vat {
                  value
                  currency {
                    code
                  }
                }
              }
            }
            ... on SellSpecificationBaggageNew {
              __typename
              sellPriceBaggage {
                travelerId
                hasMultipleWeightOptions
                options {
                  numberOfUnits
                  weight
                  weightUnit
                  preselected
                  price {
                    markup {
                      value
                    }
                    price {
                      value
                    }
                    vat {
                      value
                    }
                  }
                }
              }
            }
            ... on SellSpecificationSeatingSeatMapNew {
              __typename
              sellSeatMapBounds {
                id
                sellSeatMapSegments {
                  ... on SellSeatMapSegmentNew {
                    __typename
                    id
                    travelerIds
                    bestPriceCharacteristics {
                      characteristic
                      price
                    }
                    lowerDeck {
                      cabins {
                        rows {
                          characteristics
                          rowNumber
                          sellSeatMapSeats {
                            column
                            isBookable
                            price {
                              price {
                                value
                              }
                              markup {
                                value
                              }
                            }
                            row
                            seat
                            type
                            mainCharacteristic
                          }
                        }
                        sellSeatMapColumnDetails {
                          columnName
                          type
                        }
                      }
                    }
                    mainDeck {
                      cabins {
                        rows {
                          characteristics
                          rowNumber
                          sellSeatMapSeats {
                            column
                            isBookable
                            price {
                              price {
                                value
                              }
                              markup {
                                value
                              }
                            }
                            row
                            seat
                            type
                            mainCharacteristic
                          }
                        }
                        sellSeatMapColumnDetails {
                          columnName
                          type
                        }
                      }
                    }
                    upperDeck {
                      cabins {
                        rows {
                          characteristics
                          rowNumber
                          sellSeatMapSeats {
                            column
                            isBookable
                            price {
                              price {
                                value
                              }
                              markup {
                                value
                              }
                            }
                            row
                            seat
                            type
                            mainCharacteristic
                          }
                        }
                        sellSeatMapColumnDetails {
                          columnName
                          type
                        }
                      }
                    }
                  }
                  ... on SellSeatingPreference {
                    __typename
                    price {
                      price {
                        value
                      }
                      markup {
                        value
                      }
                    }
                    id
                  }
                  ... on SellSeatingBeside {
                    __typename
                    price {
                      price {
                        value
                      }
                      markup {
                        value
                      }
                    }
                    id
                  }
                }
              }
            }
            ... on SellSpecificationTravelerChoiceNew {
              __typename
              availableChoices {
                id
                name
                descriptions {
                  text
                  type
                }
                pricePerTravelers {
                  travelerId
                  price {
                    price {
                      value
                    }
                  }
                }
              }
              preselectedChoice
              pricePerTravelers {
                travelerId
                price {
                  markup {
                    value
                    currency {
                      code
                    }
                  }
                  price {
                    value
                    currency {
                      code
                    }
                  }
                  vat {
                    value
                    currency {
                      code
                    }
                  }
                }
              }
            }
            ... on SellSpecificationTravelerNew {
              __typename
              sellPriceTravelers {
                travelerId
                price {
                  markup {
                    value
                    currency {
                      code
                    }
                  }
                  price {
                    value
                    currency {
                      code
                    }
                  }
                  vat {
                    value
                    currency {
                      code
                    }
                  }
                }
              }
            }
          }
        }
        checkedBaggageSummary {
          tripSummaries {
            baggageDetails {
              pieces
              weight
              weightUnit
            }
            baggageStatus
          }
        }
        cabinBaggageTripSummary {
          cabinBaggageTravelerDetails {
            cabinBaggageDetails {
              pieces
              weight
              weightUnit
            }
            cabinBaggageStatus
          }
        }
        personalItemTripSummary {
          personalItemTravelerDetails {
            personalItemStatus
            travelerId
          }
        }
        features {
          availability
          code
          group
          name
        }
        id
        name
        selectionKey
        travelerPrices {
          price {
            markup {
              currency {
                code
                exponent
                name
              }
              value
            }
            price {
              currency {
                code
                exponent
                name
              }
              value
            }
            vat {
              currency {
                code
                exponent
                name
              }
              value
            }
          }
          taxesAndFees {
            taxes {
              amount {
                currency {
                  code
                  exponent
                  name
                }
                value
              }
              code
              title
            }
            category
          }
          travelerId
          id
        }
        travelerPricesWithoutPaymentDiscounts {
          price {
            markup {
              currency {
                code
                exponent
                name
              }
              value
            }
            price {
              currency {
                code
                exponent
                name
              }
              value
            }
            vat {
              currency {
                code
                exponent
                name
              }
              value
            }
          }
          taxesAndFees {
            taxes {
              amount {
                currency {
                  code
                  exponent
                  name
                }
                value
              }
              code
              title
            }
            category
          }
          travelerId
          id
        }
        travelers {
          frequentFlyerCard {
            results {
              boundIndex
              segmentIndex
              status
            }
            cardType
            cardTypeId
            cardTypeName
            number
          }
          age
          ageType
          birthDate
          firstName
          fullName
          gender
          id
          lastName
          name
          passportNumber
        }
      }
      includedExtraProducts {
        id
        texts {
          name
          productSummaryAlternativeName
          readMoreText
          receiptText
          salesAbstract
        }
      }
      availableExtraProducts(excludedExtraProducts: $excludedExtraProductIds) {
        productId: id
        name
        code
        selectedWithTrip
        productSpecificTexts {
          ... on InsuranceTexts {
            termsUrl
            title
            description
            inclusions {
              title
              description
            }
            disclaimer
            ipid {
              name
              url
            }
          }
          ... on SeatMapTexts {
            seatMapSegmentTexts {
              boundIndex
              segmentIndex
              text
            }
          }
          ... on ProductSegmentAvailabilityTexts {
            __typename
            productSegmentAvailabilityTexts {
              loungeInfo {
                closeAt
                loungeName
                openAt
                terminal
                amenities {
                  code
                  id
                  name
                }
                conditions {
                  code
                  description
                }
              }
              arrivalAirport
              available
              boundIndex
              boundType
              departureAirport
              departureDateTime
              extSystem
              flightNumber
              segmentIndex
            }
          }
        }
        sellSpecification {
          ... on SellSpecificationTravelerExternalChoiceNew {
            preselectedChoice
            externalChoices {
              ... on DistribusionChoice {
                externalChoiceId
                ancillaryOption
                distribusionChoiceBoundData {
                  arrivalDateTime
                  arrivalStation
                  boundAndSegmentIndices {
                    boundIndex
                    segmentIndex
                  }
                  departureDateTime
                  departureStation
                  fareClass
                  transferCarrier
                  transferCarrierLogo
                  termsAndConditions
                  transferTime
                  transferType
                }
                pricePerTravelers {
                  price {
                    price {
                      value
                    }
                  }
                  travelerId
                }
              }
            }
          }
          ... on SellSpecificationNoneNew {
            __typename
            price {
              markup {
                value
                currency {
                  code
                }
              }
              price {
                value
                currency {
                  code
                }
              }
              vat {
                value
                currency {
                  code
                }
              }
            }
          }
          ... on SellSpecificationBaggageNew {
            __typename
            sellPriceBaggage {
              travelerId
              hasMultipleWeightOptions
              options {
                numberOfUnits
                weight
                weightUnit
                preselected
                price {
                  markup {
                    value
                  }
                  price {
                    value
                  }
                  vat {
                    value
                  }
                }
              }
            }
          }
          ... on SellSpecificationSeatingSeatMapNew {
            __typename
            sellSeatMapBounds {
              id
              sellSeatMapSegments {
                ... on SellSeatMapSegmentNew {
                  __typename
                  id
                  travelerIds
                  bestPriceCharacteristics {
                    characteristic
                    price
                  }
                  lowerDeck {
                    cabins {
                      rows {
                        characteristics
                        rowNumber
                        sellSeatMapSeats {
                          column
                          isBookable
                          price {
                            price {
                              value
                            }
                            markup {
                              value
                            }
                          }
                          row
                          seat
                          type
                          mainCharacteristic
                        }
                      }
                      sellSeatMapColumnDetails {
                        columnName
                        type
                      }
                    }
                  }
                  mainDeck {
                    cabins {
                      rows {
                        characteristics
                        rowNumber
                        sellSeatMapSeats {
                          column
                          isBookable
                          price {
                            price {
                              value
                            }
                            markup {
                              value
                            }
                          }
                          row
                          seat
                          type
                          mainCharacteristic
                        }
                      }
                      sellSeatMapColumnDetails {
                        columnName
                        type
                      }
                    }
                  }
                  upperDeck {
                    cabins {
                      rows {
                        characteristics
                        rowNumber
                        sellSeatMapSeats {
                          column
                          isBookable
                          price {
                            price {
                              value
                            }
                            markup {
                              value
                            }
                          }
                          row
                          seat
                          type
                          mainCharacteristic
                        }
                      }
                      sellSeatMapColumnDetails {
                        columnName
                        type
                      }
                    }
                  }
                }
                ... on SellSeatingPreference {
                  __typename
                  price {
                    price {
                      value
                    }
                    markup {
                      value
                    }
                  }
                  id
                }
                ... on SellSeatingBeside {
                  __typename
                  price {
                    price {
                      value
                    }
                    markup {
                      value
                    }
                  }
                  id
                }
              }
            }
          }
          ... on SellSpecificationTravelerChoiceNew {
            __typename
            availableChoices {
              id
              name
              descriptions {
                text
                type
              }
              pricePerTravelers {
                travelerId
                price {
                  price {
                    value
                  }
                }
              }
            }
            preselectedChoice
            pricePerTravelers {
              travelerId
              price {
                markup {
                  value
                  currency {
                    code
                  }
                }
                price {
                  value
                  currency {
                    code
                  }
                }
                vat {
                  value
                  currency {
                    code
                  }
                }
              }
            }
          }
          ... on SellSpecificationTravelerNew {
            __typename
            sellPriceTravelers {
              travelerId
              price {
                markup {
                  value
                  currency {
                    code
                  }
                }
                price {
                  value
                  currency {
                    code
                  }
                }
                vat {
                  value
                  currency {
                    code
                  }
                }
              }
            }
          }
        }
        configuration {
          travelerDetails {
            persuasionEnabled
            showPricePerBound
            showPricePerTraveler
            highlightProduct
          }
          productPreSelection
        }
      }
      bounds {
        boundId: id
        includedCheckedBaggage {
          ...IncludedCheckedBaggage
        }
        segments {
          ... on TripSegment {
            __typename
            arrivedAt
            aircraftType
            brandedFareInformation {
              name
            }
            includedCheckedBaggage {
              ...IncludedCheckedBaggage
            }
            cabinClassName
            departuredAt
            destination {
              code
              name
              cityCode
              cityName
              isAirport
            }
            duration
            equipmentCode
            flightNumber
            segmentId: id
            marketingCarrier {
              code
              name
              logo {
                small
                large
              }
            }
            numberOfTechnicalStops
            technicalStops {
              arrivalAt
              departureAt
              duration
              location {
                code
                name
                cityName
                cityCode
              }
            }
            operatingCarrier {
              code
              name
            }
            operatingInformation
            ticketingCarrier {
              code
              name
            }
            origin {
              code
              name
              cityCode
              cityName
              isAirport
            }
            segmentDetails {
              paxType
              numberOfSeatsLeft
            }
          }
          ... on EventSegment {
            __typename
            duration
            types
            segmentId: id
          }
        }
      }
      changes {
        ... on TripPriceChange {
          id
          priceNew {
            price {
              value
              currency {
                code
              }
            }
          }
          priceOld {
            price {
              value
              currency {
                code
              }
            }
          }
        }
        ... on TripScheduleChange {
          id
          arrivalTimeNew
          arrivalTimeOld
          departureTimeNew
          departureTimeOld
          segmentId
        }
      }
      frequentFlyerCardTypes {
        id
        name
      }
      paymentMethodPrices {
        name
        id
        price {
          value
        }
        type
      }
      travelers {
        age
        ageType
        id
      }
      travelerPrices {
        id
        price {
          markup {
            value
          }
          price {
            value
            currency {
              code
            }
          }
          vat {
            value
          }
        }
        taxesAndFees {
          category
          taxes {
            code
            title
            amount {
              value
            }
          }
        }
        travelerId
      }
      travelerPricesWithoutPaymentDiscounts {
        price {
          markup {
            value
          }
          price {
            value
          }
          vat {
            value
          }
        }
        taxesAndFees {
          category
          taxes {
            code
            title
            amount {
              value
            }
          }
        }
        travelerId
      }
      tripCharacteristics
      checkedBaggageSummary {
        tripSummaries {
          travelerId
          baggageDetails {
            pieces
            weight
            weightUnit
          }
          baggageStatus
        }
      }
      cabinBaggageTripSummary {
        cabinBaggageTravelerDetails {
          cabinBaggageDetails {
            pieces
            weight
            weightUnit
          }
          cabinBaggageStatus
          travelerId
        }
      }
      personalItemTripSummary {
        personalItemTravelerDetails {
          personalItemStatus
          travelerId
          personalItemDetails {
            size3d {
              height
              length
              width
            }
          }
        }
      }
      includedCabinBaggage {
        includedPersonalItem
        pieces
        size3d {
          height
          length
          width
        }
        weight
        weightUnit
      }
      includedCheckedBaggage {
        ...IncludedCheckedBaggage
      }
      type
      systems
      voucherAmount {
        value
      }
      shareableUrl
    }
  }
`);
